import { ACTION_TYPES } from "../../constant/actionTypes";

export const initialState = {
  expire: null,
  code: null,
  token: null,
  loading: false,
  error:null,
  ErrorMessage: null,
  success:false,
  qrUrl:null,
  is2FARequired:false,
  is2FACompleted:false,
  key:null,
  credentials:null,
  email:null,
  user: {}
};

export const AuthReducer = function(state = initialState, action) {
  switch (action.type) {
    case ACTION_TYPES.AUTH.SET_STATE:
      return { ...state, ...action.payload, email:action.payload.email };
    case ACTION_TYPES.AUTH.WORKER.LOAD_CURRENT_ACCOUNT:
      return { ...state, ...action.payload };
    case ACTION_TYPES.AUTH.WORKER.LOAD_LOGOUT:
      return { ...initialState };
    case ACTION_TYPES.AUTH.ASYNC.TWO_FACTOR_REQUEST:
      return{
        ...state,
        is2FARequired:true,
        loading: true,
        error:null,
        token:action.payload.token,
        email: action.payload.email,
      };
    case ACTION_TYPES.AUTH.ASYNC.SET_QR_URL:
      return{
        ...state,
        qrUrl:action.payload.qrUrl,
      };
      case ACTION_TYPES.AUTH.ASYNC.SET_BASIC_DATA_2FA:
        return{
          ...state,
          email:action.payload.email,
          password:action.payload.token,
        }
      case ACTION_TYPES.AUTH.ASYNC.SET_KEY:
        return{
          ...state,
          key:action.payload.key,
        } 
    case ACTION_TYPES.AUTH.ASYNC.TWO_FACTOR_SUCCESS:
      return {
        ...state,
        qrUrl: action.payload,
        is2FACompleted:false,
        loading:false,
        error:null,
      };
    case  ACTION_TYPES.AUTH.ASYNC.TWO_FACTOR_FAILURE:
      return {
        ...state,
        error: action.payload,
        is2FARequired:false
      };
    case  ACTION_TYPES.AUTH.ASYNC.TWO_FACTOR_VERIFY_REQUEST:
      return {
        ...state,
        token:action.payload.token,
        email:action.payload.email,
        is2FARequired: true,
        loading:true,
        error: null
      };
    case ACTION_TYPES.AUTH.ASYNC.TWO_FACTOR_VERIFY_SUCCESS:
      return {
        ...state,
        is2FARequired: false,
        is2FACompleted:true,
        loading:false,
        error:null,
        success:true,
      };
    case ACTION_TYPES.AUTH.ASYNC.TWO_FACTOR_VERIFY_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading:false,
        is2FACompleted:false,
        ErrorMessage : action.payload,
        success:false
      }
      case ACTION_TYPES.AUTH.ASYNC.CLEAR_2FA_ERROR:
        return{
          ...state,
          ErrorMessage: null,
          error:null,
        }
    default:
      return state;
  }
};
